/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "TAX_DISCHARGED/LOADER_STATUS";
export const PROFILE_INFO = "TAX_DISCHARGED/PROFILE_INFO";
export const SET_VARIANCE_DATA = "TAX_DISCHARGED/SET_VARIANCE_DATA";

export const SET_CASH_ITC_DATA = "TAX_DISCHARGED/SET_CASH_ITC_DATA";
export const SET_CASH_ITC_AGG_DATA = "TAX_DISCHARGED/SET_CASH_ITC_AGG_DATA";
export const SET_LATE_FEE_DATA = "TAX_DISCHARGED/SET_LATE_FEE_DATA";
export const SET_TAX_TYPE_WISE_DATA = "TAX_DISCHARGED/SET_TAX_TYPE_WISE_DATA";

export const SET_CLEAR_GRAPH = "TAX_DISCHARGED/SET_CLEAR_GRAPH";
